import { render, staticRenderFns } from "./BioBreakButton.vue?vue&type=template&id=60086789&"
import script from "./BioBreakButton.vue?vue&type=script&lang=js&"
export * from "./BioBreakButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports